import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "display-2 font-weight-bold mb-3" }, " Welcome to Vuetify 3 Beta ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "subheading font-weight-regular" }, [
  /*#__PURE__*/_createTextVNode(" For help and collaboration with other Vuetify developers, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("please join our online "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://community.vuetifyjs.com",
    target: "_blank"
  }, "Discord Community")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "headline font-weight-bold mb-5" }, " What's next? ", -1)
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "headline font-weight-bold mb-5" }, " Important Links ", -1)
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "headline font-weight-bold mb-5" }, " Ecosystem ", -1)
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "text-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: require('../assets/logo.svg'),
                class: "my-3",
                contain: "",
                height: "200"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "mb-4" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "mb-5",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.whatsNext, (next, i) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: i,
                      href: next.href,
                      class: "subheading mx-3",
                      target: "_blank"
                    }, _toDisplayString(next.text), 9, _hoisted_4))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "mb-5",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importantLinks, (link, i) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: i,
                      href: link.href,
                      class: "subheading mx-3",
                      target: "_blank"
                    }, _toDisplayString(link.text), 9, _hoisted_6))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "mb-5",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ecosystem, (eco, i) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: i,
                      href: eco.href,
                      class: "subheading mx-3",
                      target: "_blank"
                    }, _toDisplayString(eco.text), 9, _hoisted_8))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}